

import Vue from 'vue'


import App from './App'
import WechatPlugin from 'vux/src/plugins/wechat/index.js'
import AjaxPlugin from 'vux/src/plugins/ajax/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'

import router from './router/index'
import base64url from 'base64url'

Vue.use(WechatPlugin)
Vue.use(AjaxPlugin)
Vue.use(LoadingPlugin)

AjaxPlugin.$http.interceptors.request.use(
config => {
config.baseURL = '/wx-api/contest/'
config.timeout = 6000
let token = window.localStorage.getItem('token')
if (token) {
config.headers = {
'X-Token': token
}
} else {
console.log('no token in localstorage')
}
return config
},
error => {
return Promise.reject(error)
}
)
AjaxPlugin.$http.interceptors.response.use(
res => {

return res
},
error => {
if (error.response.status === 401) {

console.log('path: ', window.location.pathname)
console.log('search: ', window.location.search)
console.log('hash: ', window.location.hash)

window.location.href = '/user/wechat_auth/auth?state=' +
base64url.encode(JSON.stringify({'redirect_to': window.location.pathname +
window.location.search +
window.location.hash}))
}
return Promise.reject(error)
}
)



Vue.config.productionTip = false
const http = Vue.http
const wx = Vue.wechat

const jsApiList = ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareQZone', 'hideMenuItems', 'updateAppMessageShareData']
router.afterEach(function (to) {
if (!sessionStorage.getItem('initLink')) {
sessionStorage.setItem('initLink', document.URL)
}

if (window.__wxjs_is_wkwebview !== true) {
let _url = window.location.origin + to.fullPath
return handleWxConfig(_url)
}
if (window.__wxjs_is_wkwebview === true) {
return handleWxConfig(sessionStorage.getItem('initLink'))
}
})

router.beforeEach((to, from, next) => {
if (to.path) {
if (window._hmt) {
window._hmt.push(['_trackPageview', to.fullPath])
}
}
next()
})

function handleWxConfig (url) {
setTimeout(() => {
http.get('/wx-api/sign?url=' +
encodeURIComponent(url))
.then(function (res) {
let signInfo = res.data.data
signInfo.jsApiList = jsApiList
signInfo.debug = process.env.WECHAT_CONFIG_DEBUG ? process.env.WECHAT_CONFIG_DEBUG : false
wx.config(signInfo)
})
}, 400)
}

/* eslint-disable no-new */
new Vue({
router,
render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js